import styled, { css } from 'styled-components';

import { Typography } from '@speeki/global-ui-components';

import { BackgroundCircle } from '@components/atoms/BackgroundCircle/BackgroundCircle';

import { breakpoints, CONTAINER_SIDE_PADDINGS } from '@shared/constants';

export const SidebarWrapper = styled.div`
    ${({ theme: { palette } }) => css`
        background: ${palette.secondary.default};
        display: flex;
        flex-direction: column;
        height: 100%;
        padding: 24px 32px;
        position: relative;

        @media (max-width: ${breakpoints.md}px) {
            align-items: center;
            gap: 16px;
            height: auto;
            padding: ${CONTAINER_SIDE_PADDINGS.xs}px;
        }
    `}
`;

export const SidebarContent = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: space-between;
`;

export const SidebarFooter = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    margin-top: 24px;

    @media (max-width: ${breakpoints.md}px) {
        margin: 0;
        max-width: 458px;
        width: 100%;
    }
`;

export const AvatarWrapper = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 16px;

    @media (max-width: ${breakpoints.md}px) {
        flex-direction: row;
        gap: 12px;
        justify-content: center;
        position: relative;
    }
`;

export const ImageCaption = styled(Typography.TextH3_24_34)`
    ${({ theme: { palette } }) => css`
        color: ${palette.neutral.white};
        margin-bottom: 16px;

        @media (max-width: ${breakpoints.md}px) {
            margin: 0;
        }
    `}
`;

export const DescriptionWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin: 0 auto;
    max-width: 262px;
`;

export const DescriptionText = styled(Typography.TextBody_14_20)(
    ({ theme: { palette } }) => css`
        color: ${palette.neutral.white};
        text-align: center;
    `,
);

export const StyledBackgroundCircle = styled(BackgroundCircle)`
    right: -410px;
    top: 12px;
    left: unset;
    z-index: -1;
`;

export const IconCloseWrapper = styled.div`
    display: flex;
    position: absolute;
    right: 24px;
    top: 24px;

    @media (max-width: ${breakpoints.md}px) {
        right: 16px;
    }
`;

export const AdditionalDetailsWrapper = styled.div`
    ${({ theme: { palette } }) => css`
        background: linear-gradient(
            270deg,
            ${palette.secondary.default} 0%,
            ${palette.secondary.hover} 100%
        );
        display: grid;
        grid-gap: 8px;
        margin-top: 24px;
        padding: 24px 32px;
    `}
`;

export const AdditionalDetailsTitle = styled(Typography.TextBody_14_20)`
    ${({ theme: { palette } }) => css`
        color: ${palette.tertiary.disabled};
    `}
`;

export const AdditionalDetailsValue = styled(Typography.TextBody_16_24)`
    ${({ theme: { palette } }) => css`
        color: ${palette.text.white};
    `}
`;

export const ReportDetailsButton = styled.button(
    ({ theme: { palette, radius } }) => css`
        align-items: center;
        background: linear-gradient(
            270deg,
            ${palette.secondary.default} 0%,
            ${palette.secondary.hover} 61.81%
        );
        border-radius: ${radius[8]}px;
        border: none;
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        padding: 12px 24px;
        width: 100%;
    `,
);

export const ReportDetailsText = styled(Typography.TextBody_12_18)(
    ({ theme: { fontWeight, palette } }) => css`
        color: ${palette.text.white};
        font-weight: ${fontWeight.bold};
    `,
);
